import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchFormRequest } from "../../api/form";
import { getFullName } from '../../helpers/functions/employee';
import moment from "moment";

class TravelDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                employee: null,
                department: null,
                travelArea: null,
                startDate: null,
                endDate: null,
                reason: null,
                approvedBy: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchForm(instanceId)
        }
    }

    fetchForm = (id) => {
        fetchFormRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            employee,
            department,
            travelArea,
            startDate,
            endDate,
            reason,
            approvedBy,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Travel Form Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee</p>
                            {employee ? getFullName(employee) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Department</p>
                            {department ? department.departmentName : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Travel Area</p>
                            {travelArea || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Start Date</p>
                            {startDate ? moment.utc(startDate).format('MMMM Do YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">End Date</p>
                            {endDate ? moment.utc(endDate).format('MMMM Do YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Reason</p>
                            {reason || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Approved By</p>
                            {approvedBy ? getFullName(approvedBy) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default TravelDetails;

